import { OrderDetail } from '@crema/models/order';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export type OrderDetailState = {
  info?: OrderDetail;
};

const initialState: OrderDetailState = {};

export const orderDetailSlice = createSlice({
  name: 'order_detail',
  initialState,
  reducers: {
    setInfo: (state, action: PayloadAction<OrderDetail | undefined>) => {
      state.info = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setInfo } = orderDetailSlice.actions;

export default orderDetailSlice.reducer;
